module.exports = __webpack_public_path__ + "static/img/qrCode3.63b27db.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/footer/qrCode3.png
// module id = pTsC
// module chunks = 2